export const ApiQueryKey = {
	products: 'products',
	productTypes: 'product-types',
	accessories: 'accessories',
	fabricCategories: 'fabric-categories',
	fabrics: 'fabrics',

	orders: 'orders',

	admins: 'admins',
	users: 'users',

	attributeGroups: 'attribute-groups',
	attributes: 'attributes',
	attributeValues: 'attribute-values',

	roles: 'roles',
	content: 'content',
	downloadableFiles: 'downloadable-files',
} as const;

export type ApiQueryKey = (typeof ApiQueryKey)[keyof typeof ApiQueryKey];
